module.exports = __webpack_public_path__ + "static/nutzungsmischung_und_zentren_halb-3ef091871341f511c11e2689d553dde5.png";